module.exports = __webpack_public_path__ + "static/media/logo-알고케어@2x.055a9f0f.png";